// De voertuigselector in de hero. Leest voertuig-index.json en laat per stap
// alleen keuzes zien die artikelen opleveren, met een teller erbij.
//
// De vier keuzes werken los van elkaar: wie zijn auto kent begint bij het merk,
// wie alleen de naam op zijn carburateur kan lezen begint rechts. Alles wat je
// invult knijpt de andere lijsten verder dicht.

(function () {
  const kiezer = document.querySelector('[data-rv-kiezer]');
  if (!kiezer) return;

  const taal = kiezer.dataset.taal === 'en' ? 'en' : 'nl';
  const doel = kiezer.dataset.doel || '/collections/all';
  const velden = {
    merk: kiezer.querySelector('[data-rv-merk]'),
    model: kiezer.querySelector('[data-rv-model]'),
    jaar: kiezer.querySelector('[data-rv-jaar]'),
    carb: kiezer.querySelector('[data-rv-carb]'),
  };
  const knop = kiezer.querySelector('[data-rv-zoek]');
  const teller = kiezer.querySelector('[data-rv-teller]');
  const soortknoppen = kiezer.querySelectorAll('[data-rv-soort]');

  const woord = {
    nl: {
      merk: 'Kies een merk', model: 'Kies een model', modelEerst: 'Eerst een merk',
      jaren: 'Alle jaren', carb: 'Alle merken',
      een: 'artikel past', meer: 'artikelen passen',
      geen: 'Niets gevonden voor deze keuze',
    },
    en: {
      merk: 'Choose a make', model: 'Choose a model', modelEerst: 'Make first',
      jaren: 'All years', carb: 'All makes',
      een: 'product fits', meer: 'products fit',
      geen: 'Nothing found for this choice',
    },
  }[taal];

  let index = null;
  let soort = 'auto';

  // Alle jaartallen die als filterwaarde in de winkel bestaan, uit beide velden.
  const alleJaren = { van: [], tot: [] };
  const verzamelJaren = () => {
    const van = new Set(), tot = new Set();
    for (const s of ['auto', 'motor']) {
      for (const merk of Object.values(index[s] || {})) {
        for (const model of Object.values(merk)) {
          for (const [a, b] of model.p) {
            if (a != null) van.add(a);
            if (b != null) tot.add(b);
          }
        }
      }
    }
    alleJaren.van = [...van].sort((x, y) => x - y);
    alleJaren.tot = [...tot].sort((x, y) => x - y);
  };

  // ------------------------------------------------------------- hulpstukken

  const vul = (veld, keuzes, eerste, bewaarKeuze) => {
    const oud = bewaarKeuze ? veld.value : '';
    veld.innerHTML = '';
    const leeg = document.createElement('option');
    leeg.value = '';
    leeg.textContent = eerste;
    veld.appendChild(leeg);
    for (const k of keuzes) {
      const optie = document.createElement('option');
      optie.value = k.waarde;
      optie.textContent = k.aantal == null ? k.naam : k.naam + ' (' + k.aantal + ')';
      veld.appendChild(optie);
    }
    if (oud && keuzes.some((k) => k.waarde === oud)) veld.value = oud;
    veld.disabled = keuzes.length === 0;
  };

  // Elk artikel is [bouwjaar_van, bouwjaar_tot, carburateurmerk, volgnummer].
  //
  // Wat de teller belooft, moet de winkel ook laten zien. Daarom filteren we
  // hier precies zoals Shopify dat straks doet: een artikel zonder bekend
  // bouwjaar valt buiten een jaarkeuze, en een artikel zonder bekend
  // carburateurmerk valt buiten een merkkeuze. Wat we niet weten, beloven we niet.
  const past = (rij, jaar, carb) => {
    const [van, tot, merk] = rij;
    if (jaar) {
      if (van == null && tot == null) return false;
      if (van != null && jaar < van) return false;
      if (tot != null && jaar > tot) return false;
    }
    if (carb && merk !== carb) return false;
    return true;
  };

  const modellenVan = (merk) => (index && index[soort] && index[soort][merk]) || {};

  // Alle artikelen die na de huidige keuzes overblijven, eventueel zonder een
  // van de filters mee te rekenen (om de keuzelijst daarvan te kunnen vullen).
  function rijen({ merk, model, jaar, carb }) {
    // Een revisieset past vaak op meerdere modellen en staat dan onder elk
    // model in de lijst. Het volgnummer houdt hem hier bij elkaar.
    const gezien = new Set();
    const uit = [];
    const merken = merk ? { [merk]: modellenVan(merk) } : (index[soort] || {});
    for (const [merknaam, modellen] of Object.entries(merken)) {
      if (merk && merknaam !== merk) continue;
      for (const [modelnaam, gegevens] of Object.entries(modellen)) {
        if (model && modelnaam !== model) continue;
        for (const rij of gegevens.p) {
          if (!past(rij, jaar, carb)) continue;
          if (gezien.has(rij[3])) continue;
          gezien.add(rij[3]);
          uit.push(rij);
        }
      }
    }
    return uit;
  }

  const keuze = () => ({
    merk: velden.merk.value,
    model: velden.model.value,
    jaar: velden.jaar.value ? Number(velden.jaar.value) : null,
    carb: velden.carb.value,
  });

  // --------------------------------------------------------- de keuzelijsten

  function vulMerken() {
    const k = keuze();
    const merken = Object.keys((index && index[soort]) || {}).map((merk) => ({
      waarde: merk,
      naam: merk,
      aantal: rijen({ merk, model: '', jaar: k.jaar, carb: k.carb }).length,
    })).filter((m) => m.aantal > 0);

    vul(velden.merk, merken, woord.merk, true);
  }

  function vulModellen() {
    const k = keuze();
    if (!k.merk) {
      vul(velden.model, [], woord.modelEerst);
      velden.model.disabled = true;
      return;
    }
    const modellen = Object.keys(modellenVan(k.merk)).map((naam) => ({
      waarde: naam,
      naam,
      aantal: rijen({ merk: k.merk, model: naam, jaar: k.jaar, carb: k.carb }).length,
    })).filter((m) => m.aantal > 0);

    vul(velden.model, modellen, woord.model, true);
  }

  function vulJaren() {
    const k = keuze();
    const alles = rijen({ merk: k.merk, model: k.model, jaar: null, carb: k.carb });
    const bekend = alles.filter(([van, tot]) => van != null || tot != null);

    if (!bekend.length) {
      vul(velden.jaar, [], woord.jaren);
      velden.jaar.disabled = true;
      return;
    }

    const laagste = Math.min(...bekend.map(([van]) => van).filter((v) => v != null));
    const hoogste = Math.max(...bekend.map(([, tot]) => tot).filter((t) => t != null).concat(laagste));

    const jaren = [];
    for (let jaar = laagste; jaar <= hoogste; jaar++) {
      const aantal = alles.filter((rij) => past(rij, jaar, k.carb)).length;
      if (aantal > 0) jaren.push({ waarde: String(jaar), naam: String(jaar), aantal });
    }
    vul(velden.jaar, jaren, woord.jaren, true);
  }

  function vulCarburateurs() {
    const k = keuze();
    const alles = rijen({ merk: k.merk, model: k.model, jaar: k.jaar, carb: '' });
    const geteld = {};
    for (const [, , merk] of alles) if (merk) geteld[merk] = (geteld[merk] || 0) + 1;
    // alles bevat al unieke artikelen, dus dit telt elk product een keer

    const lijst = Object.entries(geteld)
      .map(([naam, aantal]) => ({ waarde: naam, naam, aantal }))
      .sort((a, b) => b.aantal - a.aantal || a.naam.localeCompare(b.naam));

    vul(velden.carb, lijst, woord.carb, true);
  }

  function toonTeller() {
    const k = keuze();
    const gekozen = k.merk || k.model || k.jaar || k.carb;
    if (!gekozen) { teller.textContent = ''; knop.disabled = true; return; }

    const aantal = rijen(k).length;
    teller.textContent = aantal === 0
      ? woord.geen
      : aantal + ' ' + (aantal === 1 ? woord.een : woord.meer);
    knop.disabled = aantal === 0;
  }

  // Na elke keuze alle andere lijsten opnieuw vullen, zodat er nooit een keuze
  // blijft staan die niets meer oplevert.
  function ververs(behalve) {
    if (behalve !== 'merk') vulMerken();
    vulModellen();
    if (behalve !== 'jaar') vulJaren();
    if (behalve !== 'carb') vulCarburateurs();
    toonTeller();
  }

  // ------------------------------------------------------------------ zoeken

  function zoek() {
    const k = keuze();
    if (!(k.merk || k.carb)) return;

    const url = new URL(doel, window.location.origin);
    if (k.merk) url.searchParams.append('filter.p.m.voertuig.merk', k.merk);
    if (k.model) url.searchParams.append('filter.p.m.voertuig.model', k.merk + ' ' + k.model);
    if (k.carb) url.searchParams.append('filter.p.m.carb.merk', k.carb);

    if (k.jaar) {
      // Een artikel past op dit jaar als het bereik het omsluit. Shopify kent
      // alleen losse jaartallen als filterwaarde, geen groter-dan of kleiner-dan.
      // Daarom sturen we aan beide kanten elk jaartal mee dat aan die kant van
      // de streep valt: binnen een filter geldt OF, tussen filters geldt EN.
      for (const v of alleJaren.van) {
        if (v <= k.jaar) url.searchParams.append('filter.p.m.voertuig.bouwjaar_van', String(v));
      }
      for (const t of alleJaren.tot) {
        if (t >= k.jaar) url.searchParams.append('filter.p.m.voertuig.bouwjaar_tot', String(t));
      }
    }
    window.location.href = url.toString();
  }

  // ------------------------------------------------------------- aan de praat

  velden.merk.addEventListener('change', () => { velden.model.value = ''; ververs('merk'); });
  velden.model.addEventListener('change', () => ververs('model'));
  velden.jaar.addEventListener('change', () => ververs('jaar'));
  velden.carb.addEventListener('change', () => ververs('carb'));
  knop.addEventListener('click', zoek);

  for (const sk of soortknoppen) {
    sk.addEventListener('click', () => {
      soort = sk.dataset.rvSoort;
      for (const q of soortknoppen) q.setAttribute('aria-pressed', String(q === sk));
      for (const v of Object.values(velden)) v.value = '';
      ververs();
    });
  }

  fetch(kiezer.dataset.index)
    .then((r) => r.json())
    .then((data) => { index = data; verzamelJaren(); ververs(); })
    .catch(() => { teller.textContent = woord.geen; });
})();
